export type { SessionStore, PendingUserInfo } from './types'

import { SessionStoreImpl } from './local/store'

export const useSessionStore = SessionStoreImpl.getInstance